import { IFooterData } from './interfaces';

import { ROUTE_PATHS } from '../../contants/ROUTE_PATHS';

export const footerBarData: IFooterData = {
  copyrightText: '&copy 2022-2025 Reliht is a trademark of Isaiah 601, Inc. All rights reserved worldwide.',
  footerItems: [
    {
      heading: 'Get Started',
      links: [
        {
          title: 'Sign Up',
          linkURL: ROUTE_PATHS.INDIVIDUAL_PATH,
        },
      ],
    },
    {
      heading: 'Legal',
      links: [
        {
          title: 'Terms & Conditions',
          linkURL: ROUTE_PATHS.TERMS_CONDITIONS,
        },

        {
          title: 'Privacy Policy',
          linkURL: ROUTE_PATHS.PRIVACY_POLICY,
        },
      ],
    },
    {
      heading: 'About Reliht™',
      links: [
        {
          title: 'Equipping and Sharing',
          linkURL: ROUTE_PATHS.ABOUT_RELYHT,
        },
      ],
    },
    {
      heading: 'Connect',
      links: [
        {
          title: 'Support',
          linkURL: ROUTE_PATHS.CONNECT,
        },

        // {
        //   title: 'Vote for New Features',
        //   linkURL: ROUTE_PATHS.CONNECT,
        // },
      ],
    },
    {
      heading: 'Follow',
      links: [
        {
          title: 'Facebook',
          linkURL: ROUTE_PATHS.UNDER_CONSTRUCTION,
        },

        {
          title: 'Instagram',
          linkURL: ROUTE_PATHS.UNDER_CONSTRUCTION,
        },
      ],
    },
  ],
};
